<template>
  <div class="flex gap-6 items-start">
    <span>
      {{
        i18n(translations.caption, {
          referencePrice: i18n.price(referencePrice),
        })
      }}
    </span>
    <RevTooltip
      alignment="left"
      class="z-[1] mt-[1px]"
      content-class-names="min-w-[380px]"
      position="bottom"
    >
      <template #trigger="{ show, hide }">
        <button
          :aria-label="i18n(translations.tooltipAriaLabel)"
          @click="showTooltip(show)"
          @focusin="showTooltip(show)"
          @focusout="hide"
          @mouseenter="showTooltip(show)"
          @mouseleave="hide"
        >
          <IconInfo size="16" />
        </button>
      </template>
      <div>
        <b>{{ i18n(translations.tooltipTitle) }}</b
        ><br />
        {{ i18n(translations.tooltipContent) }}
      </div>
    </RevTooltip>
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './HistoricalPriceReferencePrice.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

defineProps<{
  referencePrice: Price
}>()

const showTooltip = (show: () => Promise<void>) => {
  show()
  trackClick({ name: 'pp_historical_price_tooltip', zone: 'pp_price' })
}
</script>
